import { GlobalSearchItemType } from "./GlobalSearch.types";
import { useGetSearchItemTypeLabel } from "./useGetSearchItemTypeLabel";

export type GlobalSearchItemTypeChipProps = {
  type: GlobalSearchItemType;
};

export const GlobalSearchItemTypeChip = ({ type }: GlobalSearchItemTypeChipProps) => {
  const getSearchItemTypeLabel = useGetSearchItemTypeLabel();

  return (
    <div className="py-0.5 px-1.25 preset-title-sm text-new-primary bg-surface-3 group-hover:bg-surface-1 transition duration-150 rounded-md">
      {getSearchItemTypeLabel(type)}
    </div>
  );
};
